import React from 'react';
import { Box, Grid, makeStyles, IconButton, Hidden, Tooltip } from '@material-ui/core';
import MenuTwoToneIcon from '@material-ui/icons/MenuTwoTone';
import Customization from './Customization';
import ProfileSection from './ProfileSection';
import logo_common from './../../../assets/images/new-common-logo.png';
import { drawerWidth } from './../../../store/constant';


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(1.25),
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    menuIcon: {
        fontSize: '1.5rem',
    },
    iconspace: {
        marginLeft: '20px',
        fontSize: '26px'
    }
}));


const Header = (props) => {
    const { drawerToggle } = props;
    const classes = useStyles();
    return (
        <React.Fragment>
            <Box className='logo' width={drawerWidth}>
                <Grid container justify="space-between" alignItems="center">
                    <Hidden smDown>
                        <Grid item>
                            <Tooltip arrow title='This is Beta, please consider put big amount, we are testing this website, in some hack or any case, your funds can be lost.'>
                                <Box mt={0.5}>
                                    <img src={logo_common} alt="Logo" width={110} />
                                </Box>
                            </Tooltip>
                        </Grid>
                    </Hidden>
                    <Grid item>
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="open drawer"
                            onClick={drawerToggle}
                        >
                            <MenuTwoToneIcon className={classes.menuIcon} />
                        </IconButton>
                    </Grid>
                </Grid>
            </Box>
            <div className={classes.grow} />           
            <Customization />   
            <ProfileSection />

        </React.Fragment>
    );
};

export default Header;
